import authManager from "./authManager";

class FormDebugHelper {
  /**
   * Validates form data before submission
   * @param {Object} formData - The form data object
   * @param {Object} fieldMappings - Mapping of frontend field names to backend field names
   * @returns {Object} - Validation result with errors if any
   */
  static validateFormData(formData, fieldMappings = {}) {
    const errors = [];
    const warnings = [];

    // Check for undefined or null values
    Object.entries(formData).forEach(([key, value]) => {
      if (value === undefined) {
        errors.push(`Field "${key}" is undefined`);
      } else if (value === null) {
        warnings.push(`Field "${key}" is null`);
      }
    });

    // Check file fields specifically
    const fileFields = [
      'member_photo',
      'member_education_qualification',
      'member_residential_address_proof',
      'member_recent_photographs',
      'member_reference_letter',
      'member_health_certificate'
    ];

    fileFields.forEach(field => {
      if (formData[field]) {
        if (!(formData[field] instanceof File)) {
          errors.push(`Field "${field}" should be a File object, but is ${typeof formData[field]}`);
        } else {
          console.log(`✅ File "${field}": ${formData[field].name} (${formData[field].size} bytes)`);
        }
      }
    });

    // Check references
    if (formData.references) {
      if (!Array.isArray(formData.references)) {
        errors.push('References should be an array');
      }
    }

    return {
      isValid: errors.length === 0,
      errors,
      warnings
    };
  }

  /**
   * Logs FormData contents for debugging
   * @param {FormData} formData - The FormData object to inspect
   */
  static logFormData(formData) {
    console.log('🔍 FormData Contents:');
    console.log('========================');
    
    for (let pair of formData.entries()) {
      if (pair[1] instanceof File) {
        console.log(`${pair[0]}: File - ${pair[1].name} (${pair[1].type}, ${pair[1].size} bytes)`);
      } else {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
    }
    console.log('========================');
  }

  /**
   * Checks API endpoint configuration
   */
  static checkApiConfig() {
    const apiUrl = process.env.REACT_APP_API_URL;
    if (!apiUrl) {
      console.error('❌ REACT_APP_API_URL is not defined in environment variables');
      return false;
    }
    console.log(`✅ API URL: ${apiUrl}`);
    return true;
  }

  /**
   * Checks authentication token
   */
  static checkAuth() {
     return true;
    try {
      const token = authManager.getAccessToken();
      if (!token) {
        console.error('❌ No access token found');
        return false;
      }
      console.log(`✅ Token exists (starts with: ${token.substring(0, 15)}...)`);
      return true;
    } catch (error) {
      console.error('❌ Error getting token:', error);
      return false;
    }
  }
}

export default FormDebugHelper;